/** @jsxRuntime classic */ /** @jsx createElement */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderAccordion_unstable", {
    enumerable: true,
    get: ()=>renderAccordion_unstable
});
const _reactJsxRuntime = require("@fluentui/react-jsx-runtime");
const _reactUtilities = require("@fluentui/react-utilities");
const _accordionContext = require("./AccordionContext");
const renderAccordion_unstable = (state, contextValues)=>{
    const { slots , slotProps  } = (0, _reactUtilities.getSlotsNext)(state);
    return /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.root, slotProps.root, /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(_accordionContext.AccordionContext.Provider, {
        value: contextValues.accordion
    }, slotProps.root.children));
}; //# sourceMappingURL=renderAccordion.js.map

//# sourceMappingURL=renderAccordion.js.map